module.exports = __webpack_public_path__ + "img/img4.54c8bc83.png";